<template>
    <div class="my-wrap">
			<div class="menu">
				<div class="menu-avator">
					<img :src="userInfo.avatar" alt="" />
				</div>
				<div class="menu-name">{{userInfo.userName}}</div>
				<div class="menu-phone">
					<div>手机号：</div>
					<div>{{userInfo.phone||userInfo.accountCode}}</div>
				</div>
				<div class="menu-phone">
					<div>设备号：</div>
					<div>{{macCode}}</div>
				</div>
				<div class="menu-school">{{userInfo.school}} {{userInfo.gradeClass}}</div>
				<div class="menu-item" @click="menuClick(1)" :class="actItem==1?'menu-item-act':''">
					<div class="icon-circle icon-circle1">
						<img class="icon-l" :src="actItem==1?require('../assets/my/note-text.png'):require('../assets/my/note-text-n.png')" alt="" />
					</div>
					<span>学习记录</span>
					<img class="icon-s"  :src="actItem==1?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item" @click="menuClick(2)" :class="actItem==2?'menu-item-act':''">
					<div class="icon-circle icon-circle2">
						<img class="icon-l"  :src="actItem==2?require('../assets/my/menu-board.png'):require('../assets/my/menu-board-n.png')" alt="" />
					</div>
					<span>打卡日历</span>
					<img class="icon-s" :src="actItem==2?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item" @click="menuClick(3)" :class="actItem==3?'menu-item-act':''">
					<div class="icon-circle icon-circle3">
						<img class="icon-l"  :src="actItem==3?require('../assets/my/map.png'):require('../assets/my/map-n.png')" alt="" />
					</div>
					<span>成就地图</span>
					<img class="icon-s"  :src="actItem==3?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item" @click="menuClick(4)" :class="actItem==4?'menu-item-act':''">
					<div class="icon-circle icon-circle4">
						<img class="icon-l"  :src="actItem==4?require('../assets/my/profile-circle.png'):require('../assets/my/profile-circle-n.png')" alt="" />
					</div>
					<span>修改个人信息</span>
					<img class="icon-s" :src="actItem==4?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item" @click="menuClick(5)" :class="actItem==5?'menu-item-act':''">
					<div class="icon-circle icon-circle5">
						<img class="icon-l"  :src="actItem==5?require('../assets/my/key.png'):require('../assets/my/key-n.png')" alt="" />
					</div>
					<span>修改密码</span>
					<img class="icon-s" :src="actItem==5?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item" @click="menuClick(6)" :class="actItem==6?'menu-item-act':''">
					<div class="icon-circle icon-circle6">
						<img class="icon-l"  :src="actItem==6?require('../assets/my/note-text.png'):require('../assets/my/note-text-n.png')" alt="" />
					</div>
					<span>绑定手机号码</span>
					<img class="icon-s" :src="actItem==6?require('../assets/my/arrow-circle-right-n.png'):require('../assets/my/arrow-circle-right.png')" alt="" />
				</div>
				<div class="menu-item exit">
					<div @click="goSelect">切换级别</div>
					<span style="color: #ccc;">|</span>
					<div @click="goLogin">退出登录</div>
				</div>
			</div>
			<div class="page">
				<study-history v-if="actItem==1" />
				<clock-date v-if="actItem==2" />
				<clock-map v-if="actItem==3" />
				<edit-user v-if="actItem==4" />
				<edit-password v-if="actItem==5" />
				<edit-phone v-if="actItem==6" />
			</div>
    </div>
</template>
<script>
import StudyHistory from "../components/StudyHistory.vue";
import ClockDate from "../components/ClockDate.vue";
import ClockMap from "../components/ClockMap.vue";
import EditUser from "../components/EditUser.vue";
import EditPassword from "../components/EditPassword.vue";
import EditPhone from "../components/EditPhone.vue";

export default {
	name: 'index',

	components: {
		StudyHistory,ClockDate,ClockMap,EditUser,EditPassword,EditPhone
	},

	data(){
		return {
			actItem:1,
			userInfo:{},
			macCode:localStorage.getItem('macCode')
		}
	},

	created(){
		this.getUserInfo();
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		menuClick(i){
			this.actItem = i
		},
		async getUserInfo(){//获取用户信息
			if(JSON.parse(localStorage.getItem("userInfo")).accountCode == "13312345678"){
				this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
				return
			}
			
			let res = await this.$api.userInfo({});
			
			if (res.data.success) {
				this.userInfo = res.data.data
				localStorage.setItem("userInfo",JSON.stringify(res.data.data))
			}else{
			  this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
		goSelect(){
			this.$router.push({  //核心语句
			  path:'/select',   //跳转的路径
			  query:{}
			})
		},
		goLogin(){
			this.$confirm('是否退出登录?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				localStorage.removeItem("userInfo");
				localStorage.removeItem("authorization");
				localStorage.removeItem("userCode");
			  this.$router.push({  //核心语句
			    path:'/login',   //跳转的路径
			    query:{}
			  })
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.my-wrap{
	padding: 2rem;
	display: flex;
	justify-content: space-between;
	.menu{
		padding-top: 2.5rem;
		width: 21.9rem;
		height: 52.1rem;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		.menu-avator{
			width: 7rem;
			height: 7rem;
			border-radius: 0rem 0rem 0rem 0rem;
			margin-bottom: 2rem;
			border-radius: 100%;
			img{
				width: 7rem;
				height: 7rem;
				border-radius: 100%;
			}
		}
		.menu-name{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
			margin-bottom: 1.5rem;
		}
		.menu-phone,.menu-school,.menu-item{
			width: 18.9rem;
			height: 2.9rem;
			background: #F8F9FB;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 1rem;
			color: #1D1D1D;
			line-height: 1.4rem;
			margin-bottom: 1.3rem;
			padding: 0 1rem;
			box-sizing: border-box;
			cursor: pointer;
		}
		.exit{
			justify-content: space-around;
			cursor: auto;
			div{
				cursor: pointer;
			}
		}
		.menu-phone{
			justify-content: space-between;
		}
		.menu-school{
			justify-content: center;
		}
		.menu-item{
			font-weight: 500;
			.icon-circle{
				width: 1.6rem;
				height: 1.6rem;
				border-radius: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-right: 0.7rem;
			}
			.icon-circle1{
				background-color: #3DD9B3;
			}
			.icon-circle2{
				background-color: #FF7474;
			}
			.icon-circle3{
				background-color: #7288FA;
			}
			.icon-circle4{
				background-color: #F9AB72;
			}
			.icon-circle5{
				background-color: #EEA8FD;
			}
			.icon-circle6{
				background-color: #56B8FF;
			}
			.icon-l{
				width: 0.8rem;
				height: 0.8rem;
			}
			.icon-s{
				width: 1.2rem;
				height: 1.2rem;
				margin-left: auto;
			}
		}
		.menu-item-act{
			color: #FFFFFF;
			background: rgb(100, 45, 113);
			border: 0.05rem solid #E0E0E0;
			.icon-circle{
				background-color: #fff;
			}
		}
	}
	.page{
		width: 72.6rem;
		height: 52.1rem;
		background: #FFFFFF;
		border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
	}
}
</style>
